import {
    IDocumentos,
    IFile,
    IListarDocumentoTemplateRequest,
    IPreenchimentoTemplateRequest,
} from "../../../Interfaces/Geral/Documentos/DocumentosInterface";
import {
    DocumentoCasoContaService,
    DocumentoCasoContaVistoriaService,
    GetAssinaturasCasoDocumentoService,
    GetDocumentoTemplateService,
    InserirDocumentoCasoService,
    ListarDocTemplateService,
    ListarDocumentoTemplatePorClassificacaoService,
    ListarDocumentoTemplateService,
    ListarDocumentoTemplateTipoDocumentoService,
    ListarModulosService,
    ListarUraTelefoneService,
    PreencherTemplateEmailClienteService,
    SetVariaveisDocumentoService,
} from "../../../Services/Geral/Documentos/DocumentosServices";

import toastr from "toastr";
import { Controller } from "../../Controller";

export async function InserirDocumentoCasoController(requestBody: IDocumentos) {
    return Controller(InserirDocumentoCasoService(requestBody));
}

export async function InserirListaDocumentosCasoController(
    files: Array<IFile>,
    IDCaso: number
) {
    return await Promise.all(
        files.map(async (file) => {
            return await InserirDocumentoCasoController({
                DS_DOCUMENTO: file.name,
                File: file,
                ID_CASO: IDCaso,
                ID_TIPO_DOCUMENTO: file.ID_TIPO_DOCUMENTO || 0,
            });
        })
    ).then((res) => {
        toastr.success(
            "Todos os arquivos foram anexados neste atendimento com sucesso!"
        );
        return res;
    });
}

export async function ListarDocumentoTemplateController(
    requestBody?: IListarDocumentoTemplateRequest
) {
    return Controller(ListarDocumentoTemplateService(requestBody));
}

export async function ListarDocumentoTemplatePorClassificacaoController(
    idTipoCaso: number,
    idClassificacaoDocumento: number,
    flAtivo: boolean
) {
    return Controller(
        ListarDocumentoTemplatePorClassificacaoService(
            idTipoCaso,
            idClassificacaoDocumento,
            flAtivo
        )
    );
}

export async function SetVariaveisDocumentoController(
    idDocumentoTemplate: number,
    idCaso: number,
    IdModulo: number,
    idParcela?: number,
    idChaveERP?: string
) {
    return Controller(
        SetVariaveisDocumentoService(
            idDocumentoTemplate,
            idCaso,
            IdModulo,
            idParcela,
            idChaveERP
        )
    );
}

export async function PreencherTemplateEmailClienteController(
    idDocumentoTemplate: number,
    requestBody: IPreenchimentoTemplateRequest
) {
    return Controller(
        PreencherTemplateEmailClienteService(idDocumentoTemplate, requestBody)
    );
}
export async function ListarDocTemplateController() {
    return Controller(ListarDocTemplateService());
}

export async function ListarUraTelefoneController() {
    return Controller(ListarUraTelefoneService());
}

export async function ListarModulosController() {
    return Controller(ListarModulosService());
}

export function ListarDocumentosDeContratoController(idProduto: number) {
    return ListarDocumentoTemplateController({
        FL_CONTRATO: true,
        idProduto,
    });
}

export async function DocumentoCasoContaController(
    idCasoConta: number,
    dsDocumento?: string,
    idCaso?: number
) {
    return Controller(
        DocumentoCasoContaService(idCasoConta, dsDocumento, idCaso)
    );
}

export async function DocumentoCasoContaVistoriaController(
    idCasoConta: number,
    dsDocumento?: string,
    idCaso?: number
) {
    return Controller(
        DocumentoCasoContaVistoriaService(idCasoConta, dsDocumento, idCaso)
    );
}

export async function GetDocumentoTemplateController(
    idDocumentoTemplate: number
) {
    return Controller(GetDocumentoTemplateService(idDocumentoTemplate));
}

export async function ListarDocumentoTemplateTipoDocumentoController(
    ID_TIPO_DOCUMENTO: number
) {
    return Controller(
        ListarDocumentoTemplateTipoDocumentoService(ID_TIPO_DOCUMENTO)
    );
}

export async function GetAssinaturasCasoDocumentoController(
    idCasoConta: number
) {
    return Controller(GetAssinaturasCasoDocumentoService(idCasoConta));
}
